<template>
  <v-container class="px-2" style="max-width: 800px;">
    <div style="display:flex" class="my-2 align-center" />



    <v-menu
    :open-on-hover="true"
    offset-y
    offset-x
    right
    top
    :nudge-right="-20"
    :nudge-top="-10"
  >
    <template v-slot:activator="{ on }">
      <v-avatar
        size="60"
        color="success"
        style="position:fixed; bottom:50px; left:20px; z-index:1; cursor:pointer;"
        v-on="on"
        @click.stop="whatsappWeb()"
      >
        <IconWhatsapp
          color="white"
          :size="42"
        />
      </v-avatar>
    </template>
    <v-card color="terciary darken-1">
      <v-card-text class="pa-2 white--text caption">
        ¿Necesitas ayuda? Escríbenos ahora...
      </v-card-text>
    </v-card>
  </v-menu>







    <!--loader de informacion-->
    <div v-show="GetValidacionEnCurso.consultando && !GetFormularioEnviado && !GetEditando">
      <AvisosUsuario :mostrar="true" :validando="true" :mensaje="GetValidacionEnCurso.mensaje" />
    </div>

    <!--error al cargar el token-->
    <div v-show="!GetValidacionEnCurso.consultando && GetValidacionEnCurso.error && !tokenValidado">

      <AvisosUsuario :mostrar="true" :validando="false" :mensaje="GetValidacionEnCurso.mensaje" />
    </div>
    <!--documentos enviados-->
    <div v-show="GetFormularioEnviado">
      <AvisosUsuario :mostrar="true" :validando="false" :mensaje="mensEnvio" />
    </div>


    <!--Stepper-->
    <div v-show="tokenValidado && !GetFormularioEnviado">
      <!--!validando&& GetCodigoValidado-->
      <div>

        <section>
          <h3 class="font-weight-light">
            Formulario
          </h3>

          <transition name="transition-opacity">
            <div>
              <h2 style="overflow-wrap:anywhere; display:inline;">
                SOLICITUD DE OTORGACIÓN DE CREDENCIAL DE ACCESO A LA PLATAFORMA AJ EN LÍNEA
              </h2>
            </div>
          </transition>
        </section>
      </div>

      <div v-if="tokenValidado && !GetFormularioEnviado">
        <CustomAlert v-show="pasoN===3" type="warning" class="mb-2" style="width:100%">
          <template v-slot:icon>
            !
          </template>
          <strong>IMPORTANTE:</strong>&nbsp;Los documentos <strong>PDF</strong> adjuntos sólo son válidos escaneados con
          sus respectivas firmas y sellos.
        </CustomAlert>
        <CustomAlert v-show="pasoN===2" type="warning" class="mb-2" style="width:100%">
          <template v-slot:icon>
            !
          </template>
          <strong>IMPORTANTE:</strong>&nbsp;La información registrada <strong>será validada</strong> con el Servicio
          General de Identificación Personal SEGIP.
        </CustomAlert>
        <div>
          <v-stepper v-model="e1">
            <v-stepper-header>
              <template v-for="n in steps">
                <v-stepper-step :complete="e1 > n" :step="n" style="cursor: pointer" @click="cambiarPaso(n)">
                  Paso {{ n }}
                </v-stepper-step>

                <v-divider v-if="n !== steps" :key="n" />
              </template>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content v-for="n in steps" :key="`${n}-content`" :step="n">
                <!--SIN-->
                <div v-if="n === 1">
                  <v-spacer class="hide-on-movile" />
                  <h2>Información de la Empresa</h2><v-spacer class="hide-on-movile" />
                  <InformacionSin />
                  <v-spacer class="hide-on-movile" />

                </div>

                <!--SEGIP-->
                <div v-if="n === 2">
                  <v-spacer class="hide-on-movile" />
                  <h2>Información del Representante</h2><v-spacer class="hide-on-movile" />
                  <InformacionRepresentante />
                  <v-spacer class="hide-on-movile" />
                </div>

                <!--Documentos-->
                <div v-else-if="n === 3">
                  <v-spacer class="hide-on-movile" />
                  <h2>Documentos Legales</h2><v-spacer class="hide-on-movile" />
                  <v-card>
                    <div style="text-align: center;">
                      <v-flex sx12>
                        <br>

                        <UploadFileCredenciales ref="refSolicitudAutorizacionDocumentosredenciales"
                          :solicitud-id="GetDatosGuardados.resultado.solicitudId"
                          :criterio="'DOCS. SOLICITUD CREDENCIAL VIA WEB'" :accepted-files="['pdf']" />
                      </v-flex>
                    </div>
                    <br>
                  </v-card>
                  <v-spacer class="hide-on-movile" />
                  <h2>Términos y Envío de Información</h2><v-spacer class="hide-on-movile" />
                  <EnvioInformacionTotal :actualizar="actualizar" />

                </div>


                <v-btn color="primary" @click="nextStep(n)" :disabled="!enBtnSiguiente"> SIGUIENTE </v-btn>
                <v-btn flat @click="prevStep(n)" :disabled="n == 1"> {{ btnAtras }} </v-btn>
              </v-stepper-content>
            </v-stepper-items>

          </v-stepper>
        </div>
      </div>
    </div>


    <!--dialog INICIAL-->
    <div
      v-show="!GetFormularioEnviado && !GetValidacionEnCurso.error && !GetValidacionEnCurso.consultando && GetValidacionEnCurso.exito">
      <template>
        <v-layout row justify-center>
          <v-dialog v-model="dialog" persistent max-width="800">
            <template v-slot:activator="{ on }">

            </template>
            <v-card>
              <v-card-title>
                <h2 class="primary--text">
                  CONFIRMAR ENVÍO DE SOLICITUD
                </h2>
              </v-card-title>
              <v-card-text>
                <span>
                  Tenga en cuenta que el código de verificación de correo sólo tiene validéz de 60 minutos. Durante ese tiempo debe completar el proceso de solicitud de credenciales. Caso contrario, deberá volver a iniciar el proceso de solicitud desde el inicio.
                </span>
                <br>
                <br>
                <span>
                  También, recordarle que se requiere que tenga a mano los siguientes requisitos en formato PDF, ya sean digitales o escaneados de los originales, para cargarlos en el último paso de su solicitud de credenciales. Estos requisitos son:
                </span>
                <br>
                <br>
                <span>
                  1) Matrícula actualizada registro de comercio (SEPREC)
                </span>
                <br>
                <span>
                  2) Cédula de identidad del representante legal o propietario
                </span>
                <br>
                <span>
                  3) Certificado inscripción padrón nacional de contribuyentes (SIN)
                </span>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="green darken-1" flat @click="dialog = false">
                  ACEPTAR
                </v-btn>

              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </template>
    </div>

  </v-container>

</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import types from '@/store/types/SolicitudCredenciales'
import InformacionRecuperadaEmpresa from '../components/SolicitudCredenciales/InformacionRecuperadaEmpresa.vue';
import InformacionRecuperadaRepresentante from '../components/SolicitudCredenciales/InformacionRecuperadaRepresentante.vue';
import AvisosUsuario from '../components/SolicitudCredenciales/AvisosUsuario.vue';
import EnvioInformacionTotal from '../components/SolicitudCredenciales/EnvioInformacionTotal.vue';
import CustomAlert from "@/components/CustomAlert.vue";
import UploadFileCredenciales from '../components/SolicitudCredenciales/uploadFileCredenciales.vue';
import InformacionSin from '../components/SolicitudCredenciales/InformacionSin.vue';
import InformacionRepresentante from '../components/SolicitudCredenciales/InformacionRepresentante.vue';
import IconWhatsapp from "@/components/Icons/IconWhatsapp"

export default {
  components: {
    AvisosUsuario,
    CustomAlert,
    UploadFileCredenciales,
    EnvioInformacionTotal,
    InformacionRecuperadaEmpresa,
    InformacionRecuperadaRepresentante,
    InformacionSin,
    InformacionRepresentante,
    IconWhatsapp,
  },
  data() {
    return {
      e1: 1,
      steps: 3,
      codigo: null,
      validando: true,
      //codigoValidado : false
      enBtnSiguiente: false,
      btnAtras: "Atrás",
      enviado: false,
      mensEnvio: "",
      dialog: false,
      tokenValidado: false,
      //editando:false
      messageWhatsapp: '',
      urlContactoWhatsappSoporte: `https://wa.me/${process.env.VUE_APP_NUMBER_WHATSAPP_SOPORTE}?text=`,
      pasoN:1,
    }
  },
  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    },
    GetDatosSin: {
      handler() {
        this.enBtnSiguiente = this.GetDatosSin.resultado.dependencia && this.GetDatosSin.resultado.telefonoEmpresa
      },
      deep: true
    },
    GetValidacionSegip() {
      this.enBtnSiguiente = this.GetValidacionSegip.status
    },
  },
  created() {
    this.token = this.$route.params.codigo
    localStorage.setItem("tokenC", this.$route.params.codigo)
  },
  mounted() {
    this.cargarInformacion()


  },
  methods: {
    actualizar() {
      this.SetDocumentosCargados(this.$refs.refSolicitudAutorizacionDocumentosredenciales[0].getDocumentosToRow())
    },
    nextStep(n) {
      if (n == 1) {

        this.enBtnSiguiente = this.GetValidacionSegip.status
      }
      if (n == 2) {
        //this.
        this.enBtnSiguiente = false
      }
      this.e1 = n + 1;
      this.pasoN = n+1;
    },
    prevStep(n) {
      if (n == 2) {
        this.enBtnSiguiente = this.GetDatosSin.resultado.dependencia && this.GetDatosSin.resultado.telefonoEmpresa
      }
      if (n == 3) {
        this.enBtnSiguiente = this.GetValidacionSegip.status
      }
      this.e1 = n - 1;
      this.pasoN = n-1;
    },
    cambiarPaso(n) {
      if (n == 1) {
        this.e1 = n
        this.enBtnSiguiente = this.GetDatosSin.resultado.dependencia && this.GetDatosSin.resultado.telefonoEmpresa
        this.pasoN = n
      }
      if (n == 2) {
        if ((this.GetDatosSin.resultado.dependencia && this.GetDatosSin.resultado.telefonoEmpresa) || this.GetValidacionSegip.status) {
          this.e1 = n
          this.enBtnSiguiente = this.GetValidacionSegip.status
          this.pasoN = n
        }
      }
      if (n == 3) {
        if (this.GetDatosSin.resultado.dependencia && this.GetDatosSin.resultado.telefonoEmpresa && this.GetValidacionSegip.status) {
          this.e1 = n
          this.enBtnSiguiente = false
          this.pasoN = n
        }
      }
    },
    cargarInformacion() {
      this.SetEditando(false)
      this.RecuperarDatosGuardados({ token: this.token }).then((response) => {
        this.tokenValidado = true
        this.SetEditando(true)
        this.dialog = response != null
        this.mensEnvio = `Su solicitud ya fue enviada correctamente.
Se envió el correo de confirmación de su solicitud al correo electrónico: ${this.GetDatosGuardados.resultado.correoNotificacionEmpresa}. Verifique su buzón de correo.
En un plazo no mayor a dos días hábiles, recibirá un correo con la respuesta a su solicitud con sus credenciales asignadas.`
      }).catch()

    },
    whatsappWeb(){
      this.messageWhatsapp = `Hola, escribo para realizar la siguiente consulta:`
      window.open(this.urlContactoWhatsappSoporte + encodeURIComponent(this.messageWhatsapp), '_blank')
    },
    ...mapMutations({
      SetDatosGuardados: types.mutations.SetDatosGuardados,
      SetDocumentosCargados: types.mutations.SetDocumentosCargados,
      SetEditando: types.mutations.SetEditando,
    }),
    ...mapActions({
      RecuperarDatosGuardados: types.actions.RecuperarDatosGuardados,
    })
  },
  computed: {
    ...mapGetters({
      GetDatosGuardados: types.getters.GetDatosGuardados,
      GetValidacionEnCurso: types.getters.GetValidacionEnCurso,
      GetDocumentosCargados: types.getters.GetDocumentosCargados,
      GetFormularioEnviado: types.getters.GetFormularioEnviado,
      GetDatosSin: types.getters.GetDatosSin,
      GetDatosRepresentante: types.getters.GetDatosRepresentante,
      GetValidacionSegip: types.getters.GetValidacionSegip,
      GetEditando: types.getters.GetEditando,
    }),
  },

}

</script>

